import { Client, StateUpdateData, RswResponse } from '@chegg/rio-sdk-web'
import { EventSchemas } from './eventSchemas'
import * as versionData from './json/versions.json'

type VersionTuple = {
  name: string
  version: string
}
type VersionData = {
  map: VersionTuple[]
}

// Version getter based on app's event data versions:
const versions: VersionData = versionData
const getEventTypeVersion = (eventName: string): string => {
  const nameAndVersion = versions.map.find(({ name }: { name: string }) => eventName === name)
  if (!nameAndVersion) {
    throw new Error(
      `${eventName} is not a valid event name.  Please confirm you are using the correct chegg-event-spec package.`
    )
  }
  return nameAndVersion.version
}

// Guard against SSR scenario:
// tslint:disable-next-line: strict-type-predicates
const win = typeof window === 'object' ? window : ({} as Window)

win.wtaCmd = win.wtaCmd || []

export type RswOptions = {
  stateUpdate?: StateUpdateData
  force?: boolean
}

export type RioEvent = (eventSpecss: EventSchemas, eventConfig?: RswOptions) => Promise<RswResponse>
export const rioEvent: RioEvent = ({ data, type }, config = {}) => {
  const { stateUpdate, force = false } = config

  // Obtain the version of the event being sent, in order to include it in the payload:
  const version = getEventTypeVersion(type)

  // Return a promise that resolves when the server has responded:
  return new Promise((resolve, reject) => {
    win.wtaCmd.push((client: Client) => {
      if (stateUpdate) {
        client.updateState(stateUpdate)
      }
      const meta = {
        version,
        eventTime: new Date(),
      }
      const eventSpecs = { type, data, meta }
      const eventOpts = { force }
      client
        ._nakedEvent<EventSchemas['data'], EventSchemas['type']>(eventSpecs, eventOpts)
        .then(resolve)
        .catch(reject)
    })
  })
}
